module.exports = __webpack_public_path__ + "static/media/Homepage_woman_tablet_1140_1120.62ed2bd3.jpg";